import dayjs from "dayjs";
import router from "../../router";
import services from "../services";

const strict = true;

const defaultState = function () {
  return {
    toSearchAppointments: "",
    toSearchAppointmentsArchive: "",
    stateFilterAppointments: [
      "PENDING",
      "TOBERESCHEDULED",
      "MEMBERCHANGE",
      "ACCEPTED"
    ],
    stateFilterAppointmentsArchive: [
      "REQUESTCANCELLEDBYNEST",
      "REQUESTCANCELLEDBYMEMBER",
      "REQUESTCANCELLEDBYPORTAL",
      "APPOINTMENTCANCELLEDBYNEST",
      "APPOINTMENTCANCELLEDBYMEMBER",
      "APPOINTMENTCANCELLEDBYPORTAL",
      "APPOINTMENTCANCELLEDCONFIRMED",
      "DONE",
      "DONE_NOTBILLABLE",
      "NOTDONE",
      "INBILL"
    ],
    appointmentsDashboard: [],
    numberOfAppointmentsDashboard: 0,
    appointments: [],
    numberOfAppointments: 0,
    appointmentsArchive: [],
    numberOfAppointmentsArchive: 0,
    appointment: {},
    cancelReasons: [],
    hasAlmostOneFondoEstAppointment: false
  };
};

const state = defaultState();

const getters = {
  toSearchAppointments: state => state.toSearchAppointments,
  toSearchAppointmentsArchive: state => state.toSearchAppointmentsArchive,
  stateFilterAppointments: state => state.stateFilterAppointments,
  stateFilterAppointmentsArchive: state => state.stateFilterAppointmentsArchive,
  // dashboard appointments
  appointmentsForDashboard: state => state.appointmentsDashboard,
  numberOfAppointmentsDashboard: state => state.numberOfAppointmentsDashboard,
  // appointments
  appointments: state => state.appointments,
  appointmentsForAppointments: state => {
    return [...state.appointments].sort((c, d) =>
      dayjs(c.appointmentRequestDate).isAfter(dayjs(d.appointmentRequestDate))
        ? -1
        : 1
    );
  },
  numberOfAppointments: state => state.numberOfAppointments,
  // archived appointments
  appointmentsArchive: state => state.appointmentsArchive,
  appointmentsArchiveForArchived: state => {
    return [...state.appointmentsArchive].sort((c, d) =>
      dayjs(c.appointmentRequestDate).isAfter(dayjs(d.appointmentRequestDate))
        ? -1
        : 1
    );
  },
  numberOfAppointmentsArchive: state => state.numberOfAppointmentsArchive,
  // appointment detail object
  appointment: state => state.appointment,
  cancelReasons: state => state.cancelReasons,
  getHasAlmostOneFondoEstAppointment: state =>
    state.hasAlmostOneFondoEstAppointment
};

const mutations = {
  reset(state) {
    const s = defaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  updateToSearchAppointmentsField(state, value) {
    state.toSearchAppointments = value;
  },
  updateToSearchAppointmentsArchiveField(state, value) {
    state.toSearchAppointmentsArchive = value;
  },
  appointmentsDashboard(state, payload) {
    state.appointmentsDashboard = payload.appointments;
    state.numberOfAppointmentsDashboard = Number(payload.numberOfAppointments);
    state.hasAlmostOneFondoEstAppointment =
      payload.hasAlmostOneFondoEstAppointment;
  },
  appointments(state, payload) {
    state.appointments = payload.appointments;
    state.numberOfAppointments = Number(payload.numberOfAppointments);
  },
  appointmentsArchive(state, payload) {
    state.appointmentsArchive = payload.appointments;
    state.numberOfAppointmentsArchive = Number(payload.numberOfAppointments);
  },
  appointment(state, appointment) {
    state.appointment = appointment;
  },
  addComment(state, payload) {
    let idx = state.appointments.findIndex(
      appointment => payload.id === appointment.id
    );
    if (idx > -1) {
      state.appointments[idx].commentList.push(payload.comment);
    }
  },
  deleteComment(state, payload) {
    let idx = state.appointments.findIndex(
      appointment => payload.appointmentId === appointment.id
    );
    if (idx > -1) {
      let commentIdx = state.appointments[idx].commentList.findIndex(
        comment => comment.id == payload.commentId
      );
      state.appointments[idx].commentList.splice(commentIdx, 1);
    }
  },
  cancelReasons(state, reasons) {
    let sorted = reasons.sort((a, b) => {
      let titleA = a?.title?.it_IT.toLowerCase();
      let titleB = b?.title?.it_IT.toLowerCase();
      // "Altro" sempre in fondo
      if (titleA === "altro") return 1;
      if (titleB === "altro") return -1;
      // Applica ordinamento alfabetico
      return titleA.localeCompare(titleB, "it-IT");
    });
    state.cancelReasons = sorted;
  }
};

const actions = {
  updateToSearchAppointmentsField({ commit }, toSearch) {
    commit("updateToSearchAppointmentsField", toSearch);
  },
  updateToSearchAppointmentsFieldAndReloadAppointments(
    { commit, dispatch },
    toSearch
  ) {
    commit("updateToSearchAppointmentsField", toSearch);
    return dispatch("getAppointments", "appointments");
  },
  updateToSearchAppointmentsArchiveField({ commit }, toSearch) {
    commit("updateToSearchAppointmentsArchiveField", toSearch);
  },
  updateToSearchAppointmentsArchiveFieldAndReloadAppointments(
    { commit, dispatch },
    toSearch
  ) {
    commit("updateToSearchAppointmentsArchiveField", toSearch);
    return dispatch("getAppointments", "archive");
  },
  async getNextAppointments({ commit }, num) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      let result = await services.appointmentService.callGetNextAppointments(
        num
      );
      commit("appointmentsDashboard", result);
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
      commit("error/setError", reason, { root: true });
      throw reason;
    }
  },
  async getAppointments({ commit, state }, from) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      let toSearchFilter = null;
      let stateFilter = null;
      if (from && from === "appointments") {
        toSearchFilter = state.toSearchAppointments;
        stateFilter = state.stateFilterAppointments.join(",");
      }
      if (from && from === "archive") {
        toSearchFilter = state.toSearchAppointmentsArchive;
        stateFilter = state.stateFilterAppointmentsArchive.join(",");
      }
      let result = {};
      if (stateFilter) {
        result = await services.appointmentService.callGetAppointmentsSearch({
          toSearch: toSearchFilter,
          state: stateFilter
        });
      }
      if (from && from === "appointments" && result) {
        commit("appointments", result);
      }
      if (from && from === "archive" && result) {
        commit("appointmentsArchive", result);
      }
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
      commit("error/setError", reason, { root: true });
      throw reason;
    }
  },
  async getAppointment({ commit }, id) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      let appointment = await services.appointmentService.getAppointment(id);
      commit("appointment", appointment);
      return appointment;
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async getAppointmentForMobileApp({ commit }, id) {
    try {
      let appointment = await services.appointmentService.getAppointment(id);
      commit("appointment", appointment);
      return appointment;
    } catch (error) {
      commit("error/setError", error, { root: true });
    }
  },
  async getMemberContactInfo({ commit }, appointemntId) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      return await services.appointmentService.callGetMemberContactInfo(
        appointemntId
      );
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async getMemberContactInfoForMobileApp({ commit }, appointemntId) {
    try {
      return await services.appointmentService.callGetMemberContactInfo(
        appointemntId
      );
    } catch (error) {
      commit("error/setError", error, { root: true });
    }
  },
  async cancelAppointment({ commit }, payload) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      let res = await services.appointmentService.cancel(payload);
      router.replace({ name: "richiestePrenotazioni" });
      return res;
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async modifyDate({ commit }, payload) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      return await services.appointmentService.modifyDate(payload);
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async acceptModifyDate({ commit }, id) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      return await services.appointmentService.acceptModifyDate(id);
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async getRejectReasons({ commit }) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      let res = await services.appointmentService.getRejectReasons(
        "APPOINTMENT_CANCELED_BYMEMBER"
      );
      commit("cancelReasons", res);
      return res;
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async openVoucherPreview({ commit }, voucherId) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      let response = await services.appointmentService.downloadVoucher(
        voucherId
      );
      let fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(fileURL, "_blank");
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  addComment({ commit }, payload) {
    commit("addComment", {
      id: payload.appointmentId,
      comment: payload.comment
    });
  },
  deleteComment({ commit }, payload) {
    commit("deleteComment", payload);
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
